import React from 'react';
import { IApplicationContext } from '../IApplicationContext';

export const ThermalPrinterApplicationContext = React.createContext<IApplicationContext>(undefined as any);
